import { state,transition,animate,trigger,style, stagger ,query} from '@angular/animations'

export const elementAnimation = trigger('elementAnimation',[
    transition(':enter', [
          style({ opacity: 0 }),
          animate('0.25s', style({ opacity: 1 })),
    ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('0.25s', style({ opacity: 0 }))
      ])
])